import { SET_SITE_INFO } from '../actions/set-site-info';

const initialState = {};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_SITE_INFO:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/site-info.js